import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class CessionService {
  constructor(private http: HttpClientService) {}

  public createCession(date): Observable<any> {
    const params = { date };
    return this.http.post("/api/cession", params).pipe(tap((_) => console.log("CessionService.createCesion: Ok.")));
  }

  public sendCession(drive_file_id: string, id: number, status: string) {
    const params = {
      drive_file_id,
      status,
      id,
    };
    return this.http
      .post(`/api/cession/${id}/send_cession`, params)
      .pipe(tap((_) => console.log("CessionService.sendCession: Ok.")));
  }

  public show(id): Observable<any> {
    return this.http.get(`/api/cession/${id}`).pipe(tap((_) => console.log("CessionService.show: Ok")));
  }

  public getAllCessions({ search_id = undefined, page = undefined, page_size = undefined }) {
    const options = {
      params: {
        page,
        page_size,
        search_id,
      },
    };
    return this.http.get("/api/cession", options).pipe(tap((_) => console.log("CessionService.getAllCessions: Ok.")));
  }

  public updateCession(account_id: number, investor_id: number) {
    const params = {
      account_id,
      investor_id,
    };
    return this.http
      .post(`/api/cession/${investor_id}/change_cession`, params)
      .pipe(tap((_) => console.log("CessionService.change_cession: Ok.")));
  }

  public updateCreditCession(id: number, params: any) {
    return this.http
      .put(`/api/cession/${id}`, params)
      .pipe(tap((_) => console.log("CessionService.updateCreditCession: Ok.")));
  }

  public sendAssignmentsCxc(id: number | string, send: boolean = false) {
    const params = {
      send,
    };
    return this.http
      .post(`/api/cession/${id}/send_assignments_to_cxc`, params)
      .pipe(tap((_) => console.log("CessionService.sendAssignmentsCxc: Ok.")));
  }

  public sendCessions(date) {
    const params = { date };
    return this.http
      .post("/api/cession/send_cessions", params)
      .pipe(tap((_) => console.log("CessionService.sendCesions: Ok.")));
  }

  public LastCession() {
    return this.http.get("/api/cession/last_cession").pipe(tap((_) => console.log("CessionService.LastCession: Ok.")));
  }

  public getIncidences({ search_id = undefined, page = undefined, page_size = undefined }) {
    const options = {
      params: {
        page,
        page_size,
      },
    };
    return this.http
      .get("/api/cession/incidences", options)
      .pipe(tap((_) => console.log("CessionService.getIncidences: Ok.")));
  }

  public deleteIncidence(id: number) {
    return this.http
      .put(`/api/cession/${id}/cancel`, null)
      .pipe(tap((_) => console.log("CessionService.deleteIncidence: Ok.")));
  }
}
